const notSupported = () => Promise.reject(new Error('react-native-file-access is not supported on web'));

export const FileSystem = {
  readFile: notSupported,
  writeFile: notSupported,
  appendFile: notSupported,
  copyFile: notSupported,
  moveFile: notSupported,
  unlink: notSupported,
  mkdir: notSupported,
  stat: notSupported,
  ls: notSupported,
  exists: () => Promise.resolve(false),
  isDir: () => Promise.resolve(false),
  hash: notSupported,
  fetch: notSupported,
  df: notSupported,
  getAppGroupDir: notSupported,
  dirs: {
    DocumentDir: '',
    CacheDir: '',
    SDCardDir: '',
    MainBundleDir: '',
  },
};

export const Dirs = FileSystem.dirs;
export default FileSystem;
